import { render, staticRenderFns } from "./PorEnviar.vue?vue&type=template&id=f3142564&scoped=true"
import script from "./PorEnviar.vue?vue&type=script&lang=js"
export * from "./PorEnviar.vue?vue&type=script&lang=js"
import style0 from "./PorEnviar.vue?vue&type=style&index=0&id=f3142564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3142564",
  null
  
)

export default component.exports